import { $t } from '@/utils/languageAuto';
import "core-js/modules/es.object.keys";
import "core-js/modules/es.object.to-string";
import { __awaiter, __decorate, __extends, __generator } from "tslib";
import { Vue, Component } from 'vue-property-decorator';
import { loading, enumData, userPrefPageSize } from '@/decorators';

var TopUpRecord = function (_super) {
  __extends(TopUpRecord, _super);

  function TopUpRecord() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.topUpSelectFieldEnum = [];
    _this.depositStatusEnum = [];
    _this.accountList = [];
    _this.bankList = [];
    _this.loadingStatus = false;
    _this.accountFormData = {};
    _this.dataList = [];
    _this.total = 0;
    _this.columns = [];
    _this.rowSelection = {};
    _this.selectedRows = [];
    _this.docTypeEnum = [{
      text: _this.t('充值单号'),
      value: _this.$enum.finance.DepositDocTypeEnum.ORDER_NUMBER
    }, {
      text: _this.t('交易流水号'),
      value: _this.$enum.finance.DepositDocTypeEnum.TRANSACTION_NUMBER
    }];
    _this.selectedList = [];
    _this.searchData = _this.getInitSearchData();
    _this.lastParams = {};
    return _this;
  }

  TopUpRecord.prototype.getInitSearchData = function () {
    return {
      _field: this.$enum.finance.DepositDocTypeEnum.ORDER_NUMBER,
      _value: '',
      status: undefined,
      payment_open_bank: undefined,
      account_code: undefined,
      business_type: this.$enum.finance.DepositBusinessTypeEnum.DEPOSIT_TOP_UP,
      time_filter_field: 'create_time',
      _timeArr: this.$util.getDefaultTimeCondition(),
      page_index: 1,
      page_size: 10
    };
  };

  TopUpRecord.prototype.created = function () {
    var _this = this;

    this.columns = [{
      title: this.t('充值单号'),
      name: 'order_number',
      dataIndex: 'order_number',
      filterEmpty: true,
      isCopy: true
    }, {
      title: this.t('交易流水号'),
      name: 'transaction_number',
      dataIndex: 'transaction_number',
      filterEmpty: true,
      isCopy: true
    }, {
      title: this.t('充值账户'),
      name: 'account',
      scopedSlots: {
        customRender: 'account'
      }
    }, {
      title: this.t('付款人'),
      name: 'payment_account_name',
      dataIndex: 'payment_account_name',
      filterEmpty: true
    }, {
      title: this.t('银行卡号/账号'),
      name: 'payment_bank_account',
      dataIndex: 'payment_bank_account',
      filterEmpty: true,
      isCopy: true
    }, {
      title: this.t('交易状态'),
      name: 'status',
      scopedSlots: {
        customRender: 'status'
      }
    }, {
      title: this.t('金额'),
      name: 'rechargeMoney',
      align: 'right',
      scopedSlots: {
        customRender: 'rechargeMoney'
      }
    }, {
      title: this.t('实际到账金额'),
      name: 'actualAmount',
      align: 'right',
      scopedSlots: {
        customRender: 'actualAmount'
      }
    }, {
      title: this.t('时间'),
      name: 'create_time',
      dataIndex: 'create_time',
      scopedSlots: {
        customRender: 'create_time'
      }
    }, {
      title: this.t('操作'),
      width: 80,
      scopedSlots: {
        customRender: 'operation'
      }
    }];
    this.rowSelection = {
      selectedRowKeys: this.selectedList,
      onChange: function onChange(selectedRowKeys, selectedRows) {
        _this.rowSelection.selectedRowKeys = _this.selectedList = selectedRowKeys;
        _this.selectedRows = selectedRows;
      }
    };
    this.queryDataList();
    this.queryAccountList();
    this.queryBankList();
  };

  TopUpRecord.prototype.queryDataList = function () {
    return __awaiter(this, void 0, Promise, function () {
      var postData, _i, _a, key, field, resData, _b, list, total;

      return __generator(this, function (_c) {
        switch (_c.label) {
          case 0:
            postData = {};

            for (_i = 0, _a = Object.keys(this.searchData); _i < _a.length; _i++) {
              key = _a[_i];

              if (!this.searchData[key] && this.searchData[key] !== 0) {
                continue;
              }

              if (key === '_timeArr' && this.searchData[key].length) {
                postData.begin_time = this.$util.formatDateTime(this.searchData[key][0]);
                postData.end_time = this.$util.formatDateTime(this.searchData[key][1]);
              } else {
                postData[key] = this.searchData[key];
              }
            }

            field = String(this.searchData._field);
            postData[field] = this.searchData._value;
            this.lastParams = this.$util.deepCopy(postData);
            return [4, this.$api.finance.queryDepositReturnList(postData)];

          case 1:
            resData = _c.sent().data;
            _b = resData.list, list = _b === void 0 ? [] : _b, total = resData.total;
            this.total = total;
            this.dataList = list;
            return [2];
        }
      });
    });
  };

  TopUpRecord.prototype.queryAccountList = function () {
    return __awaiter(this, void 0, Promise, function () {
      var _a, _b, data, code;

      return __generator(this, function (_c) {
        switch (_c.label) {
          case 0:
            return [4, this.$api.finance.queryAccountList()];

          case 1:
            _a = _c.sent(), _b = _a.data, data = _b === void 0 ? [] : _b, code = _a.code;
            this.accountList = data;
            return [2];
        }
      });
    });
  };

  TopUpRecord.prototype.queryBankList = function () {
    return __awaiter(this, void 0, Promise, function () {
      var _a, _b, data, code;

      return __generator(this, function (_c) {
        switch (_c.label) {
          case 0:
            return [4, this.$api.finance.queryBankList()];

          case 1:
            _a = _c.sent(), _b = _a.data, data = _b === void 0 ? [] : _b, code = _a.code;
            this.bankList = data;
            return [2];
        }
      });
    });
  };

  TopUpRecord.prototype.handleSearch = function () {
    this.initPage();
    this.queryDataList();
  };

  TopUpRecord.prototype.handleReset = function () {
    this.searchData = this.getInitSearchData();
    this.initPage();
    this.queryDataList();
  };

  TopUpRecord.prototype.initPage = function () {
    this.searchData.page_index = 1;
    this.rowSelection.selectedRowKeys = this.selectedList = [];
    this.selectedRows = [];
  };

  TopUpRecord.prototype.handlePageChange = function (val) {
    this.searchData.page_index = val;
    this.rowSelection.selectedRowKeys = this.selectedList = [];
    this.selectedRows = [];
    this.queryDataList();
  };

  __decorate([enumData('Finance/TopUpSelectFieldEnum')], TopUpRecord.prototype, "topUpSelectFieldEnum", void 0);

  __decorate([enumData('Finance/DepositStatusEnum')], TopUpRecord.prototype, "depositStatusEnum", void 0);

  __decorate([userPrefPageSize('depositTopUpRecordList')], TopUpRecord.prototype, "getInitSearchData", null);

  __decorate([loading('loadingStatus')], TopUpRecord.prototype, "queryDataList", null);

  TopUpRecord = __decorate([Component], TopUpRecord);
  return TopUpRecord;
}(Vue);

export default TopUpRecord;